export enum ChallengeType {
  quiz = "quiz",
  poll = "poll",
  openEnded = "open-ended",
  random = "random"
}
